import { reactive } from 'vue';
import { vehicleRequest } from '../vehicleRequest/vehicleRequest';

export const backupRequest = reactive({
  calculatePriceFromOldTripRequest(tripRequest) {
    let price = null;

    if (
      tripRequest &&
      tripRequest.trip_per_price &&
      tripRequest.distance &&
      !isNaN(tripRequest.trip_per_price) &&
      !isNaN(tripRequest.distance)
    ) {
      price = tripRequest.trip_per_price * tripRequest.distance;

      if (
        price &&
        tripRequest.trip_request_bonus &&
        tripRequest.trip_request_bonus.length > 0
      ) {
        let bonus = 0;

        tripRequest.trip_request_bonus.forEach((tripRequestBonus) => {
          if (
            tripRequestBonus.bonus &&
            tripRequestBonus.bonus.bonus_name === 'Shuttle Bonus'
          ) {
            if (tripRequestBonus.type === 'percentage') {
              bonus = (price * tripRequestBonus.base_bonus) / 100;
            } else if (
              tripRequestBonus.type === 'flat' &&
              tripRequest.working_days
            ) {
              bonus = tripRequestBonus.base_bonus / tripRequest.working_days;
              if (tripRequest.route_type === 'Both way') {
                bonus /= 2;
              }
            }
          }
        });

        price += bonus;
      }
    }

    return parseFloat(parseFloat(price).toFixed(2));
  },
  calculatePriceFromNewTripRequest(tripRequest) {
    let price = null;

    if (
      tripRequest &&
      tripRequest.fare_per_km &&
      tripRequest.distance &&
      !isNaN(tripRequest.fare_per_km) &&
      !isNaN(tripRequest.distance)
    ) {
      let shuttleBonusType = null;
      let shuttleBonus = null;

      if (
        tripRequest.trip_request_bonuses &&
        tripRequest.trip_request_bonuses.length > 0
      ) {
        tripRequest.trip_request_bonuses.forEach((tripRequestBonus) => {
          if (
            tripRequestBonus.bonus &&
            tripRequestBonus.bonus.bonus_name === 'Shuttle Bonus'
          ) {
            shuttleBonusType = tripRequestBonus.type;
            shuttleBonus = tripRequestBonus.base_bonus;
          }
        });
      }

      price = vehicleRequest.dailyIncomeWithShuttleBonusWithoutTripTimes(
        tripRequest.fare_per_km,
        tripRequest.distance,
        tripRequest.duty_days,
        shuttleBonusType,
        shuttleBonus
      );
    }

    return price;
  },
  calculatePriceFromTripRequest(tripRequest) {
    if (tripRequest && tripRequest.fare_per_km) {
      return this.calculatePriceFromNewTripRequest(tripRequest);
    } else if (tripRequest && tripRequest.trip_per_price) {
      return this.calculatePriceFromOldTripRequest(tripRequest);
    } else {
      return null;
    }
  }
});
